"use strict";
import Nav               from '../vue/components/nav';
import ResponsiveContent from '../vue/components/responsive-content';
import ShowMoreListing   from '../vue/components/show-more-listing';
import Vue               from 'vue/dist/vue.common.js';

Vue.config.debug = true;

const app = new Vue({
  el: '#VueApp',
  data: {
    title: "HELLO WORLD",
    active: false,
  },
  methods: {
    toggle() {
      this.active = !this.active;
    }
  }
});

// Check for existance of MiniApp
const miniApp = document.getElementById('MiniApp');

// Create Vue if it exists
if (miniApp) {
  const heroApp = new Vue({
    el: '#MiniApp'
  })
}

export default app;